import moment from "moment";
import React from "react";
import { IP } from "../../../../../internalServer";
import { useNavigate } from "react-router-dom";

const StudentTableActivityReview = ({
  reviewSLData,
  reviewActivitys,
  reviewActivity_id,
  setPendingPopup1,
}) => {
  const navigate = useNavigate();
  const deadline = new Date(reviewActivitys?.deadline);
  const submitted = new Date(reviewSLData?.submitted_on);
  const student_id = reviewSLData?.student_id?.id;
  const status = reviewSLData.status;

  // Get entryType and gradeScaleId from activity
  const entryType = reviewActivitys?.entryType || "Marks";
  const gradeScale = reviewActivitys?.gradeScaleId;
  const obtainedMarks = reviewSLData?.obtainedMarks;
  const obtainedGrade = reviewSLData?.obtainedGrade;
  const totalMarks = reviewActivitys?.total_marks || 0;

  // Helper function to get grade details from gradeScale
  const getGradeDetails = (grade) => {
    if (!gradeScale || !gradeScale.grades || !grade) return null;
    return gradeScale.grades.find((g) => g.grade === grade);
  };

  // Render marks or grade display
  const renderMarksOrGrade = () => {
    // 🔥 If entryType is "Grade", show grade
    if (entryType === "Grade") {
      if (obtainedGrade) {
        const gradeDetails = getGradeDetails(obtainedGrade);
        const isPass = gradeDetails?.resultStatus === "Pass";

        return (
          <span
            style={{
              backgroundColor: isPass ? "#d4edda" : "#f8d7da",
              color: isPass ? "#155724" : "#721c24",
              padding: "4px 12px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 600,
              display: "inline-block",
            }}
          >
            {obtainedGrade}
          </span>
        );
      } else {
        // No grade assigned yet - show dash
        return (
          <span
            style={{
              // backgroundColor: isPass ? "#d4edda" : "#f8d7da",
              // color: isPass ? "#155724" : "#721c24",
              padding: "4px 12px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 600,
              display: "inline-block",
            }}
          >
            —
          </span>
        );
      }
    } else {
      // 🔥 If entryType is "Marks", show marks
      return (
        <span>
          {obtainedMarks !== null && obtainedMarks !== undefined
            ? obtainedMarks
            : 0}
          /{totalMarks}
        </span>
      );
    }
  };

  const handeldata = () => {
    if (reviewSLData.status === "completed") {
      navigate("/ReviewCompletedStudentData", {
        state: {
          reviewActivity_id: reviewActivity_id,
          student_id: student_id,
          entryType: entryType,
          gradeScaleId: gradeScale,
          obtainedMarks: obtainedMarks,
          obtainedGrade: obtainedGrade,
        },
      });
    } else if (reviewSLData.status === "review") {
      navigate("/QuestionnoboxActivityReview", {
        state: {
          reviewActivity_id: reviewActivity_id,
          student_id: student_id,
          entryType: entryType,
          gradeScaleId: gradeScale,
        },
      });
    } else if (reviewSLData.status === "pending") {
      setPendingPopup1(true);
    }
  };

  return reviewSLData ? (
    <>
      <tr style={{ borderBottom: "1px solid #D9D9D9" }}>
        <td style={{ cursor: "pointer", textAlign: "start" }}>
          <img
            src={
              reviewSLData?.student_id
                ? IP +
                  reviewSLData?.student_id?.profilePicture.replace(/^\./, "")
                : reviewSLData?.student_id?.gender === "M"
                  ? reviewSLData?.student_id?.avatar_profile
                    ? "/images/Boys/" +
                      reviewSLData?.student_id?.avatar_profile +
                      ".webp"
                    : "/images/Student_boy_pic.png"
                  : reviewSLData?.student_id?.gender === "F"
                    ? reviewSLData?.student_id?.avatar_profile
                      ? "/images/Girls/" +
                        reviewSLData?.student_id?.avatar_profile +
                        ".webp"
                      : "/images/Student_girl_pic.png"
                    : "/images/default image.png"
            }
            alt="icon"
            style={{
              width: "23px",
              height: "23px",
              margin: "0px 10px",
              borderRadius: "50%",
            }}
            className=""
            key={reviewSLData?.student_id?.avatar_profile}
            onError={(e) => {
              if (reviewSLData?.student_id?.gender === "M") {
                e.target.src = reviewSLData?.student_id?.avatar_profile
                  ? "/images/Boys/" +
                    reviewSLData?.student_id?.avatar_profile +
                    ".webp"
                  : "/images/Student_boy_pic.png";
              } else if (reviewSLData?.student_id?.gender === "F") {
                e.target.src = reviewSLData?.student_id?.avatar_profile
                  ? "/images/Girls/" +
                    reviewSLData?.student_id?.avatar_profile +
                    ".webp"
                  : "/images/Student_girl_pic.png";
              } else {
                e.target.src = "/images/default image.png";
              }
            }}
          />
          <span onClick={handeldata}>{reviewSLData?.student_id?.name}</span>
        </td>

        <td>{reviewSLData?.student_id?.roll_number}</td>
        <td>{reviewActivitys?.standard_id?.name}</td>
        <td> {reviewActivitys?.section_id?.name}</td>
        <td>{moment(reviewSLData?.submitted_on).format(" DD/MM/YYYY")}</td>

        {/* 🔥 Marks/Grade Column */}
        <td>{renderMarksOrGrade()}</td>

        <td
          className={
            reviewSLData.status === "pending"
              ? "PendingColor text-capitalize"
              : "text-capitalize"
          }
        >
          {status === "review"
            ? "On Review"
            : status === "pending"
              ? "Pending"
              : "Completed"}{" "}
          {reviewSLData?.status !== "pending" && submitted > deadline && (
            <span className="delayedClass">{"(Delayed)"}</span>
          )}
        </td>
      </tr>
    </>
  ) : (
    <></>
  );
};

export default StudentTableActivityReview;
